import common from './common';

export const validationRules = {
  email: {
    required: common.validationRules.required,
    validate: common.validationRules.email,
    maxLength: common.validationRules.maxLength255,
  },
  password: {
    required: common.validationRules.required,
    minLength: {
      value: 8,
      message: 'Must be at least 8 characters long',
    },
    validate: (value) => {
      if (!/[A-Z]/.test(value)) return 'Must contain at least 1 uppercase letter';
      if (!/[a-z]/.test(value)) return 'Must contain at least 1 lowercase letter';
      if (!/[0-9!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?`~]/.test(value)) return 'Must contain at least 1 number or special character';
      return true;
    },
  },
  confirmPassword: {
    required: common.validationRules.required,
    minLength: {
      value: 8,
      message: 'Must be at least 8 characters long',
    },
    validate: (value, formValues) => value === formValues.password || 'Passwords do not match',
  },
  firstNameEng: {
    required: common.validationRules.required,
    maxLength: common.validationRules.maxLength255,
    validate: common.validationRules.englishOnly,
  },
  lastNameEng: {
    required: common.validationRules.required,
    maxLength: common.validationRules.maxLength255,
    validate: common.validationRules.englishOnly,
  },
  receiptName: {
    required: common.validationRules.required,
    maxLength: common.validationRules.maxLength255,
  },
  phone: {
    required: common.validationRules.required,
    // maxLength: common.validationRules.maxLength255,
    // minLength: {
    //   value: 8,
    //   message: 'Must be 8 characters long',
    // },
    maxLength: {
      value: 15,
      message: 'The phone number should not exceed 15 characters',
    },
    validate: (value) => /^[0-9]+$/.test(value) || 'Only numbers are allowed',
  },
  serviceId: {
    // required: common.validationRules.required,
  },
  lastNameChi: {
    maxLength: common.validationRules.maxLength255,
    validate: common.validationRules.chineseOnly,
  },
  firstNameChi: {
    maxLength: common.validationRules.maxLength255,
    validate: common.validationRules.chineseOnly,
  },
};

export const fields = {
  email: {
    name: 'email',
    label: 'Email *',
    type: 'email',
  },
  password: {
    name: 'password',
    label: 'Password *',
    type: 'password',
  },
  confirmPassword: {
    name: 'confirmPassword',
    label: 'Confirm Password *',
    type: 'password',
  },
  firstNameEng: {
    name: 'firstNameEng',
    label: 'First Name (English) *',
    type: 'text',
  },
  lastNameEng: {
    name: 'lastNameEng',
    label: 'Last Name (English) *',
    type: 'text',
  },
  receiptName: {
    name: 'receiptName',
    label: 'Name on Tax Receipt *',
    type: 'text',
    helperText: 'Used for issuing tax receipt. Default to First Name and Last Name',
  },
  phone: {
    name: 'phone',
    label: 'Phone *',
    type: 'tel',
    maxLength: 15,
  },
  serviceId: {
    name: 'serviceId',
    label: 'Which Is Your Regular Service?',
    type: 'select',
  },
  lastNameChi: {
    name: 'lastNameChi',
    label: 'Last Name (Chinese)',
    type: 'text',
    helperText: '(Optional)',
  },
  firstNameChi: {
    name: 'firstNameChi',
    label: 'First Name (Chinese)',
    type: 'text',
    helperText: '(Optional)',
  },
};

export const form = {
  create: [
    ['firstNameEng'],
    ['lastNameEng'],
    ['firstNameChi'],
    ['lastNameChi'],
    ['receiptName'],
    ['email'],
    ['phone'],
    ['password'],
    ['confirmPassword'],
    ['serviceId'],
  ],
};

export default {
  validationRules,
  fields,
  form,
};
